












import SimpleInput from '@/UI/Shared/SimpleInput.vue'
import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'
import { ResforPhone } from '@/Domain/Resfor/ResforPhone'

export default mixins(FieldModel).extend({
  name: 'PhoneField',
  components: { SimpleInput },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isValid: true
    }
  },
  computed: {
    inputStatus (): string {
      if (this.currentValue === '') {
        return ''
      }
      return this.isValid
        ? 'success'
        : 'danger'
    },
    errorMessage (): string {
      if (this.disabled) {
        return ''
      }
      return this.inputStatus === 'danger'
        ? this.$t('subasta.persoais.wrong-phone-number').toString()
        : ''
    }
  },
  methods: {
    validateInput () {
      try {
        const phone = new ResforPhone(this.currentValue + '')
        this.isValid = true
        this.emitValue(phone.phoneNumber())
        this.$emit('fieldValid', this.isValid)
      } catch {
        this.isValid = false
      }
    }
  }
})
